import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
//import toastr from "toastr";
import PlazasVacantesServices from "./plazas_vacantes_services";

export const getPlazasVacantes = (filters, type) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLAZAS_VACANTES,
      payload: true,
    });
    const resp = await PlazasVacantesServices.getPlazasVacantes(filters, type);
    dispatch({
      type: actions.GET_PLAZAS_VACANTES,
      payload: resp.data,
    });
    dispatch({
      type: actions.PLAZAS_VACANTES_FALLA,
      payload: null,
    });
    // dispatch({
    //   type: actions.FORM_PLAZA_VACANTE_FALLA,
    //   payload: null,
    // });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.PLAZAS_VACANTES_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_PLAZAS_VACANTES,
      payload: false,
    });
  }
};

/*export const getPlazaVacante = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLAZA_VACANTE,
      payload: true,
    });
    const resp = await PlazasVacantesServices.getPlazaVacante(id);
    dispatch({
      type: actions.GET_PLAZA_VACANTE,
      payload: resp.data,
    });
    dispatch({
      type: actions.PLAZA_VACANTE_FALLA,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLAZA_VACANTE_FALLA,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_PLAZA_VACANTE,
      payload: false,
    });
  }
}

 export const savePlazaVacante = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: true,
    });
   
    const resp = await IndikatorsServices.saveIndikator(req);
    const { indikators } = getState().indikators;
    
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        count: indikators.count + 1,
        data: [...indikators.data, resp.data]
      },
    });

    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: false,
    });
  }
}

export const editIndikator = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: true,
    });
    const resp = await IndikatorsServices.editIndikator(req.id, req);
    const { indikators } = getState().indikators;
    let _indikators = indikators.data.slice();
    _indikators[index] = resp.data;
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        count: indikators.count,
        data: _indikators
      },
    });
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_INDIKATOR,
      payload: false,
    });
  }
}

export const deleteIndikator = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: true,
    });
    await IndikatorsServices.deleteIndikator(id);
    const { indikators } = getState().indikators;
    let _indikators = indikators.data.slice();
    _indikators.splice(index, 1);
    dispatch({
      type: actions.GET_INDIKATORS,
      payload: {
        data: _indikators,
        count: indikators.count - 1
      }
    });
    dispatch({
      type: actions.INDIKATORS_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.INDIKATORS_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_INDIKATORS,
      payload: false,
    });
  }
} */
